import types from '../constants/AnnouncementActionTypes';
import {
  createItemFail,
  createItemSuccess,
  fetchItemFail,
  fetchItemsFail,
  fetchItemsSuccess,
  fetchItemSuccess,
  removeItemFail,
  removeItemSuccess,
  updateItemFail,
  updateItemSuccess,
} from './utils';

const initialState = {
  status: { fetch: {} },
  items: {},
};

export default function announcements(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_ANNOUNCEMENT_SUCCESS:
      return fetchItemSuccess(state, action);
    case types.FETCH_ANNOUNCEMENT_FAIL:
      return fetchItemFail(state, action);

    case types.FETCH_ANNOUNCEMENTS_ADMIN_SUCCESS:
    case types.FETCH_ANNOUNCEMENTS_SUCCESS:
      return fetchItemsSuccess(state, action);
    case types.FETCH_ANNOUNCEMENTS_FAIL:
      return fetchItemsFail(state, action);

    case types.CREATING_FAQ: {
      return { ...state, status: { ...state.status, creating: true, created: false } };
    }
    case types.CREATE_ANNOUNCEMENT_SUCCESS:
      return createItemSuccess(state, action);
    case types.CREATE_ANNOUNCEMENT_FAIL:
      return createItemFail(state, action);

    case types.UPDATE_ANNOUNCEMENT_SUCCESS:
      return updateItemSuccess(state, action);
    case types.UPDATE_ANNOUNCEMENT_FAIL:
      return updateItemFail(state, action);

    case types.DELETE_ANNOUNCEMENT_SUCCESS:
      return removeItemSuccess(state, action);
    case types.DELETE_ANNOUNCEMENT_FAIL:
      return removeItemFail(state, action);

    default:
      return state;
  }
}
